import { CLEAR_ORDER_FLOW } from '@shared/actionTypes';

export default function orderFlowReducer(reducer, initialState) {
  return (state, action) =>
    action.type === CLEAR_ORDER_FLOW ? initialState : reducer(state, action);
}
